import { STATUS_TYPE } from '../../../enum';
import { Country } from '../../country/api/interface';
import { Flavor } from '../../flavor/api/interface';
import { PromoCode } from '../../promoCode/api/interface';
import { Region } from '../../region/api/interface';
import { Shape } from '../../shape/api/interface';
// import { ToppingsCategoryItem } from '../../toppingsCategoryItem/api/interface';

export interface ToppingsCategoryItem {
  id: string;
  labelAr: string;
  labelEn: string;
  code?: string;
  price?: string | number;
  discountedPrice?: string | number;
  previewUrl: string;
  deliveryDayGap: number;
  topping_category?: {
    id: string;
    labelEn: string;
    labelAr: string;
  };
  toppingShapeImages: {
    id: string;
    shapeId: string;
    sliced: string;
    top: string;
    front: string;
  }[]
}
export interface OrderBundleComponent {
  id: string;
  componentId: string;
  componentType: string;
  productId: string;
  labelEn: string;
  labelAr: string;
  qty: number;
  unitPrice: number;
  subTotal: number;
  previewUrl?: string | null;
  category_cake?: {
    id: string;
    labelEn: string;
    labelAr: string;
    colorCode?: string;
    displayMode?: string;
    shape?: Shape;
    flavor?: Flavor;
    topping_category_item?: ToppingsCategoryItem;
  };
}

export interface OrderBundleVariantSelection {
  id: string;
  variantGroupId: string;
  variantOptionId: string;
  labelEn: string;
  labelAr: string;
  qty: number;
  price: number;
  subTotal: number;
  previewUrl?: string | null;
  variantGroupLabelEn?: string | null;
  variantGroupLabelAr?: string | null;
}

export interface OrderSummaryItem {
  type: 'cake' | 'addon' | 'bundle';
  labelEn: string;
  labelAr?: string | null;
  qty: number;
  unitPrice: number;
  subTotal: number;
  bundleProductId?: string;
  components?: OrderBundleComponent[];
  variantSelections?: OrderBundleVariantSelection[];
}

export interface OrderBundleItem {
  id: string;
  bundleProductId: string;
  labelEn: string;
  labelAr: string;
  qty: number;
  unitPrice: number;
  subTotal: number;
  previewUrl?: string | null;
  components?: OrderBundleComponent[];
  variantSelections?: OrderBundleVariantSelection[];
}

export interface OrderItems {
  id: string;
  qty: string;
  unitPrice: string;
  orderCakeId: string | null;
  addonProductVariantId: string | null;
  order_cake: {
    id: string;
    shapeLabelEn: string;
    shapeLabelAr: string;
    flavorLabelEn: string;
    flavorLabelAr: string;
    colorCode: string;
    flavorId: string;
    shapeId: string;
    toppingId: string;
    flavor: Flavor;
    shape: Shape;
    topping_category_item: ToppingsCategoryItem;
    category_cake?: {
      id: string;
      labelEn: string;
      labelAr: string;
    };
    displayMode: string;
    writeOnCake: string;
    printImageUrl: string;
    instruction: string;
    cakeBoxId?: string | null;
    cakeBox?: {
      id: string;
      labelEn: string;
      labelAr?: string;
      imgUrl?: string | null;
      price: number;
    } | null;
    shapePrice?: number | string | null;
    flavorPrice?: number | string | null;
    toppingPrice?: number | string | null;
    printPrice?: number | string | null;
    cakeBoxPrice?: number | string | null;
    totalPrice?: number | string | null;
  } | null;
  addon_product_variant: {
    id: string;
    labelEn: string;
    labelAr: string;
    previewUrl: string;
    price: string;
  } | null;
  addon_product: {
    id: string;
    labelEn: string;
    labelAr: string;
    previewUrl: string;
    price: string;
  } | null;
}

export interface FindOrder {
  status?: string | string[];
  paymentStatus?: string;
  orderDate?: string;
  limit?: number;
  skip?: number;
  search?: string;
  /** When true, list only unpaid/temp online orders */
  isTempOrder?: boolean;
  /** Derived source filter: mobile | partner | admin */
  orderSource?: string;
  /** @deprecated Prefer serviceLineStatus=pending */
  awaitingVendorResponse?: boolean;
  /** Filter orders by linked service partner line status: pending | confirmed | rejected */
  serviceLineStatus?: string;
}

export interface GetOrder {
  id: string;
}

export interface Order {
  id: string;
  orderNumber: string | null;
  onlinePaymentId?: string | null;
  /** Adori merchant ref / sequential transaction id */
  transactionId?: string | null;
  /** Unpaid online hold — listed under Temporary Orders until paid */
  isTempOrder?: boolean;
  partnerId?: string | null;
  /** mobile | partner | admin */
  orderSource?: string | null;
  orderDate: string;
  status: string;
  totalAmount: number;
  promoCodeDiscountAmount: number;
  vatAmount: number;
  deliveryFee: number;
  isIdentitySecret: boolean;
  cardMessage: {
    toUser: string;
    fromUser: string;
    message: string;
  };
  shippingAddress: {
    id: string;
    area: string;
    zone: string;
    floor: string;
    addressName: string;
    street: string;
    userId: string;
    latitude: number;
    regionId: string;
    countryId: string;
    createdAt: string;
    isDefault: boolean;
    longitude: number;
    updatedAt: string;
    postalCode: string;
    activeState: boolean;
    addressType: string;
    houseNumber: string;
    officeNumber: string;
    buildingNumber: string;
    extraDirection: string;
    apartmentNumber: string;
    region: Region;
    country: Country;
  }
  recipientInfo?: {
    name: string;
    phone: string;
  }
  isLate?: boolean | null;
  exactDeliverySlot?: string | null;
  exactDeliverySlotDate?: string | null;
  deliveryDate: {
    // amount: number;
    // paymentMethod: string;
    date: string;
    time: string;
    type: string;
  }
  additionalInfo: any;
  userDetails: {
    id: string;
    firstName: string;
    lastName: string;
    mobileNumber: string;
    email: string;
    region: Region;
  }
  country_payment_method: {
    id: string;
    labelEn: string;
    labelAr: string;
    code: string;
  }
  payment: any;
  promo_code_usage: {
    id: string;
    orderId: string;
    usageDate: string;
    promoCodeId: string;
    promo_code: PromoCode;
    // discountAmount: string;
    // discountType: string;
  }
  order_items: OrderItems[];
  order_bundle_items?: OrderBundleItem[];
  order_service_items?: any[];
  awaitingVendorResponse?: boolean;
  order_summary_items?: OrderSummaryItem[];
  itemsSubTotal?: number;
  specialRequest?: string | null;
  walletCreditUsed: number;
  rewardPointsRedeemed?: number;
  rewardPointsDiscountAmount?: number;
  rewardPointsEarned?: number;
  createdAt: Date;
  updatedAt: Date;
  createdBy: string;
  updatedBy: string;
  createdByUser?: string;
  updatedByUser?: string;
}

export interface InitialState {
  data: Order[];
  skip: number;
  limit: number;
  totalRecords: number;
  currentPage: number;
  status: STATUS_TYPE;
  isError: boolean;
  isLoading: boolean;
  isSuccess: boolean;
  errorMessage: string;
}

export const initialState: InitialState = {
  data: [],
  skip: 0,
  limit: 25,
  totalRecords: 0,
  currentPage: 0,
  status: 'idle',
  isError: false,
  isLoading: false,
  isSuccess: false,
  errorMessage: '',
};
